//chapter1
export default {
    id : 16,//chapter number
    title : '16. PFMEA 작성방법 (3) - PFMEA 구조분석',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c16.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'PFMEA 구조분석',
            ],
            body2 : [
                'PFMEA 구조분석에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '16.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '공정 FMEA 구조분석은 공정흐름도를 토대로 구성한다.',//html available
                    answer : "1",
                    explain : '공정흐름도에서 공정구조를 검토해야 한다.'
                },
                {
                    type : 'ox',
                    question : '구조분석의 공정요소는 4M 요소를 정의한다.',//html available
                    answer : "1",
                    explain : '구조분석의 공정요소는 4M 요소를 정의한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 구조분석 개요</h3>
                        <li>검토 항목<br>
                        1) 분석범위의 식별<br>
                        2) Tree 구조 혹은 동등한 프로세스 flow 다이어그램<br>
                        3) 프로세스 단계, sub 단계의 공정 element 정의<br>
                        4) 고객과 공급자 기술팀 사이의 협조  <br>
                        5) 기능분석 단계의 기초</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <h3>2. 공정흐름도 개요</h3>
                        <li>공정의 시각적 도식표현이 의사소통에 도움을 줌</li>
                        <li>지속적으로 팀이 집중할 수 있도록 유지해 줌</li>
                        <li>공정의 진행과정을 보여줌</li>
                        <li>개략적으로 기술된 내용이 세부사항을 도출하고, 구성하는데 도움을 줌</li>
                        <li>기능분석에서 공정의 특성(제품과 공정)을 작성하는데 집중할 수 있도록 도움을 줌</li>
                        <li>필요에 따라 특성 매트릭스 등의 보조 분석방법을 이용함</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <h3>3. 공정흐름도 작성</h3>
                        <li>공정은 반드시 단계로 규정되어야 함</li>
                        <li>입력물(공정특성), 출력물(제품특성) 또한 규정할 것</li>
                        <li>입력물의 관리와 출력물이 어떻게 영향을 받는지 고려</li>
                        <p class="mg10"></p>
                        <h3>4. 프로세스 STEP 작성</h3>
                        <li>프로세스와 Work element 작성</li>
                        <p class="mg10"></p>
                        <h3>5. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c16.mp4',
        },
    ]
}